import { OtherEnum } from "requests";

export const COLUMN_1 = [
  { value: OtherEnum.Dt, label: "DT" },
  { value: OtherEnum.Dtc, label: "DTC" },
  { value: OtherEnum.Cwd, label: "CWD" },
  { value: OtherEnum.Ge, label: "GE" },
  { value: OtherEnum.Gh, label: "GH" },
  { value: OtherEnum.Gm, label: "GM" },
  { value: OtherEnum.MnFx, label: "MN/FX" }
];
export const COLUMN_2 = [
  { value: OtherEnum.MxFx, label: "MX/FX" },
  { value: OtherEnum.Oaf, label: "OAF" },
  { value: OtherEnum.Onf, label: "ONF" },
  { value: OtherEnum.Om, label: "OM" },
  { value: OtherEnum.Rot, label: "ROT" },
  { value: OtherEnum.Rr, label: "RR" },
  { value: OtherEnum.Rrt, label: "RRT" }
];
export const COLUMN_3 = [
  { value: OtherEnum.Si, label: "SI" },
  { value: OtherEnum.TNv, label: "T/NV" },
  { value: OtherEnum.TPe, label: "T/PE" },
  { value: OtherEnum.TSn, label: "T/SN" },
  { value: OtherEnum.Ab, label: "AB" },
  { value: OtherEnum.At, label: "AT" }
];
